import { walletAddressStatus } from "@lib/helpers/ColorHelper";
import { WalletAddressStatus } from "@lib/types";
import { Tag, Typography } from "antd";
import { useIntl } from "react-intl";

type Props = {
  status: WalletAddressStatus;
  onlyText?: boolean;
  style?: React.CSSProperties;
};

export default function WalletAddressStatusName({
  status,
  onlyText = false,
  style,
}: Props) {
  const { messages } = useIntl();

  const statusName = messages["enums.walletAddressStatus"][status] as string;

  if (onlyText) {
    return <Typography.Text style={style}>{statusName}</Typography.Text>;
  }

  return (
    <Tag color={walletAddressStatus(status)} style={style}>
      {statusName}
    </Tag>
  );
}
